import styled from 'styled-components';

const RemoveButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: white;
  background: rgba(0, 0, 0, 0.5);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  z-index: 10;
  visibility: hidden;
`;

export const RetailerCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 180px;
  aspect-ratio: 1 / 1;
  flex-shrink: 0;
  background-color: white;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  position: relative;
  cursor: pointer;
  transition: border-color 0.15s;
  overflow: hidden;

  &:hover {
    border-color: #ccc;
  }

  &:hover ${RemoveButton} {
    visibility: visible;
  }
`;

export { RemoveButton };

export const RetailerImage = styled.img`
  width: 100%;
  flex: 1;
  object-fit: cover;
  background: #f0f0f0;
  min-height: 0;
`;

export const RetailerInfo = styled.div`
  display: flex;
  flex-direction: column;
  padding: 6px 8px;
  flex-shrink: 0;
  min-width: 0;
`;

export const RetailerName = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const AddButton = styled.div`
  width: 180px;
  aspect-ratio: 1 / 1;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f8f8;
  color: #be1622;
  font-weight: 500;
  font-size: 42px;
  border: 1px dashed #dee2e6;
  flex-shrink: 0;

  &:hover {
    background-color: #e9ecef;
    border-color: #ccc;
  }

  &:active {
    background-color: #dde1e5;
    transform: scale(0.98);
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 2px dashed #dee2e6;
  border-radius: 4px;
  background-color: #f8f9fa;
  text-align: center;
  height: 220px;
  width: 100%;
  color: #6c757d;
  cursor: pointer;
  transition:
    background-color 0.2s,
    border-color 0.2s;

  &:hover {
    background-color: #e9ecef;
    border-color: #ced4da;
  }
`;

export const EmptyMessage = styled.h5`
  font-size: 1.1rem;
  font-weight: 500;
  margin-bottom: 8px;
  color: #495057;
`;

export const EmptySubMessage = styled.p`
  font-size: 0.9rem;
  margin-top: 0;
  color: #6c757d;
`;
